<template>
  <div class="words" :class="{ tips: useTips, help: useHelp }">
    <template v-for="(word, position) of cells">
      <button
        :class="['word', { 
          help: useHelp && !isGuessed(word),
          error: isError(word),
          guessed: isGuessed(word),
        }]"
        @click="$emit('select', +position)"
      >
        <span 
          v-if="word.loading" 
          v-text="'...'"
        />
        <span
          v-else-if="getWord(word).value"
          v-text="getWord(word).value"
        />
        <span 
          v-else-if="useTips && word.tip" 
          v-text="word.tip"
        />
        <span 
          v-else 
          v-text="+position + 1"
        />
      </button>
    </template>
  </div>
</template>


<script>
export default {
  name: 'UsedWords',

  props: {
    useTips: Boolean,
    useHelp: Boolean,
    cells: {
      type: Object,
      required: true, 
    },
    answer: {
      type: Object,
      required: true, 
    },
  },

  methods: {
    getWord(word) {
      return this.answer[word.id] || {};
    },
    isError(word) {
      return this.getWord(word).valid === false;
    },
    isGuessed(word) {
      return this.getWord(word).valid === true;
    },
  },
};
</script>


<style lang="scss" scoped>
.words {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  user-select: none;
  gap: 12px;

  &.tips .word {
    width: auto;
    padding: 0 12px;
    color: var(--color-white);
  }

  &.help .word:not(.help) {
    opacity: .33;
  }

  .word {
    width: 30px;
    height: 30px;
    background-color: #C7B2F7;
    color: #4D43C6;
    border-radius: 4px;
    border: 0;
    cursor: pointer;
    font-family: Arial;
    font-weight: bold;
    font-size: 20px;
    line-height: 1;
    padding: 0;

    &.error, &.guessed {
      width: auto;
      padding: 0 12px;
      color: var(--color-white);
    }

    &.error {
      background-color: #FF4B4E;
    }
    &.guessed {
      background-color: #51BE6C;
    }
    &.help {
      background-color: #d4c4f9;
    }
  }
}
</style>